import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { FormattedMessage, intlMessageShape } from 'sb-react-intl'
import { links, constants, snowplow } from 'common/helpers'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'

import s from './NeedDataModal.scss'


class NeedDataModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    messages: PropTypes.shape({
      text: PropTypes.shape(intlMessageShape),
      title: PropTypes.shape(intlMessageShape),
      footerText: PropTypes.shape(intlMessageShape),
      buttonTitle: PropTypes.shape(intlMessageShape),
    }).isRequired,
    link: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
  }

  handleClick = () => {
    const { link } = this.props

    if (link === links.resubscribe) {
      snowplow.track(constants.snowplowEvents.resubscribeClick, {
        placement: 'need subscription popup',
      }, false)
    }
  }

  redirect = () => {
    const { item, link } = this.props

    this.close()
    actions.view.postponedPremiumProduct.setProduct(item)
    actions.models.router.push(link)
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, messages } = this.props

    return (
      <Modal name={name} title={messages.title}>
        <FormattedMessage className={s.text} tag="div" {...messages.text} />
        <Button
          className={s.button}
          title={messages.buttonTitle}
          brand
          lg
          onClick={this.redirect}
          dataTestId="modalConfirmButton"
        />
        <FormattedMessage className={s.footerText} tag="div" {...messages.footerText} onClick={this.close} />
      </Modal>
    )
  }
}


export default NeedDataModal
